import { atom } from 'jotai';

import type {
    AccountDetail,
    BankAccountDisplayDetail,
} from '../types/BankAccount';
import type { LegacyTransaction, Transaction } from '../types/Transactions';

export interface PrepopulatedAddress {
    firstName: string;
    lastName: string;
    phoneNumber: string;
    line1: string;
    line2?: string;
    city: string;
    postalCode: string;
    state?: string;
}

export const bankAccountDisplayDetails = atom<BankAccountDisplayDetail[]>([]);

export const editingSpaceAtom = atom<BankAccountDisplayDetail | null>(null);
export const selectedSpaceAtom = atom<BankAccountDisplayDetail | null>(null);
export const selectedTransactionAtom = atom<LegacyTransaction | null>(null);
export const selectedTransactionV2Atom = atom<{
    transaction: Transaction;
    syncteraAccountId: string;
} | null>(null);

export const preselectedAccountForCardAtom = atom<
    AccountDetail | BankAccountDisplayDetail | null
>(null);

export const selectedAccountForDirectDepositAtom = atom<
    AccountDetail | BankAccountDisplayDetail | null
>(null);

export const addressAtom = atom<PrepopulatedAddress | null>(null);
